import { Outlet } from 'react-router';

import { NotFound, getRoutesFromFiles } from '@sorare/routing';
import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Suspense } from '@sorare/core/src/atoms/Suspense';
import { Dialog } from '@sorare/core/src/components/dialog';
import {
  DialogKey,
  WithDialogs,
} from '@sorare/core/src/components/navigation/WithDialogs';
import { SportSwitcher } from '@sorare/core/src/contexts/sport/SportSwitcher';
import { lazy } from '@sorare/core/src/lib/retry';

/*
 * Prefer dynamic over static import into this file
 * because static ones will end up in the main bundle
 */
const GamePage = lazy(
  async () => import('./games_/$gameId/$eventType/page.tsx'),
  'GamePage'
);
const So5LeaderboardContenderDialogFromParams = lazy(
  async () =>
    import('#src/components/lineup/So5LeaderboardContenderDialogFromParams/index.tsx'),
  'So5LeaderboardContenderDialogFromParams'
);
const NBAMarketSubscriptions = lazy(
  async () => import('#src/routing/NBAMarketSubscriptions/index.tsx'),
  'NBAMarketSubscriptions'
);
const DecisivePlayerPickerDialogFromParams = lazy(
  async () =>
    import('@sorare/gameplay/src/components/missions/picker/DecisivePlayerPickerDialogFromParams'),
  'DecisivePlayerPickerDialogFromParams'
);

const NBALayout = () => {
  return (
    <WithDialogs
      dialogs={[
        {
          name: DialogKey.game,
          element: (
            <Dialog open fullScreen>
              <Suspense fallback={null}>
                <GamePage />
              </Suspense>
            </Dialog>
          ),
        },
        {
          name: DialogKey.contender,
          element: (
            <Suspense fallback={null}>
              <So5LeaderboardContenderDialogFromParams />
            </Suspense>
          ),
        },
        {
          name: DialogKey.decisivePlayerPicker,
          element: (
            <Suspense fallback={null}>
              <DecisivePlayerPickerDialogFromParams />
            </Suspense>
          ),
        },
      ]}
    >
      <SportSwitcher sport={Sport.NBA} />
      <Suspense fallback={null}>
        <NBAMarketSubscriptions />
      </Suspense>
      <Outlet />
    </WithDialogs>
  );
};

const gamePlayFiles = Object.fromEntries(
  Object.entries(
    import.meta.glob('../../../gameplay/src/pages/**/(page|layout).tsx')
  ).map(([key, value]) => [
    key.replace('../../../gameplay/src/pages/', './'),
    value,
  ])
);

export const routeObjects = [
  {
    element: <NBALayout />,
    children: [
      ...getRoutesFromFiles(
        { ...gamePlayFiles, ...import.meta.glob('./**/(page|layout).tsx') },
        '../../packages/nba/src/pages'
      ),
      { path: '*', element: <NotFound /> },
    ],
  },
];
